import React, {useState} from 'react';

import AiBotPillComponent from '../redesign/aiBotPillComponent/aiBotPillComponent';
import ToolTipComponent from '../toolTipComponent';

import VIDABOO_CONSTANTS from '../../../../config/consts';

import './pillComponent.css';

const PillComponent = ({
  pillTxt = '',
  pillType = '',
  toolTipPosition = 'right',
  toolTipTxt = '',
}) => {
  const [showToolTip, setShowToolTip] = useState(false);

  const handleToolTip = () => {
    if (toolTipTxt) {
      setShowToolTip(!showToolTip);
    }
  };

  const renderPillUI = () => {
    switch (pillType) {
      case VIDABOO_CONSTANTS.PILL_TYPES.ACTIVE:
        return (
          <div className="et-v2-pill-component-container et-v2-pc-active-pill">
            {pillTxt || 'ACTIVE'}
          </div>
        );
      case VIDABOO_CONSTANTS.PILL_TYPES.IN_ACTIVE:
        return (
          <div className="et-v2-pill-component-container et-v2-pc-in-active-pill">
            {pillTxt || 'INACTIVE'}
          </div>
        );
      case VIDABOO_CONSTANTS.PILL_TYPES.PRIMARY:
        return (
          <div className="et-v2-pill-component-container et-v2-pc-primary-pill">
            {pillTxt}
          </div>
        );
      case VIDABOO_CONSTANTS.PILL_TYPES.DELETE:
        return (
          <div className="et-v2-pill-component-container et-v2-pc-delete-pill">
            {pillTxt}
          </div>
        );
      case VIDABOO_CONSTANTS.PILL_TYPES.BETA:
        return (
          <div className="et-v2-pill-component-container et-v2-pc-beta-pill">
            {pillTxt || 'BETA'}
          </div>
        );
      case VIDABOO_CONSTANTS.PILL_TYPES.NEW:
        return (
          <div className="et-v2-pill-component-container et-v2-pc-new-pill">
            <div className="et-v2-pc-new-pill-border"></div>
            <div className="et-v2-pc-new-pill-txt-wrap">
              <div className="et-v2-pc-new-pill-txt">NEW</div>
            </div>
          </div>
        );
      case VIDABOO_CONSTANTS.PILL_TYPES.UPDATE:
        return (
          <div className="et-v2-pill-component-container et-v2-pc-update-pill">
            {pillTxt || 'UPDATE'}
          </div>
        );
      case VIDABOO_CONSTANTS.PILL_TYPES.AI_MODE_ON:
        return (
          <div className="et-v2-pill-component-container et-v2-pc-ai-pill">
            <AiBotPillComponent hideToolTip />
            {VIDABOO_CONSTANTS.AI_BOT_NAME + ' AI playground'}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div
      className="et-v2-pill-tooltip-container"
      onMouseEnter={handleToolTip}
      onMouseLeave={handleToolTip}>
      {renderPillUI()}
      {showToolTip && (
        <ToolTipComponent
          toolTipPosition={toolTipPosition}
          toolTipTxt={toolTipTxt}
        />
      )}
    </div>
  );
};

export default PillComponent;
